import styled from 'styled-components'
import {
  releaseInfoLargeDesktopUpQuery,
  releaseInfoMobileDownQuery,
  releaseInfoSmallDesktopUpQuery,
  releaseInfoTabletDownQuery,
  releaseInfoTabletUpQuery
} from '../../responsiveQueries'

export const ModalTitle = styled.h5`
  font-family: 'Nunito Sans', sans-serif;
  font-size: 20px;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.neutralW90};
  margin-bottom: 16px;
`

export const ModalDescription = styled.p`
  font-family: 'Nunito Sans', sans-serif;
  font-size: 14px;
  color: ${({ theme }) => theme.colors.neutralW70};
  margin-bottom: 24px;
`
export const TextFieldWrapper = styled.div`
  font-size: 14px;

  input,
  textarea::placeholder {
    font-size: 14px;
    color: ${({ theme }) => theme.colors.neutralW60};
  }
`

export const ActionsSectionCol = styled.div`
  box-sizing: border-box;
  position: relative;
  width: 100%;
  min-height: 1px;
  max-width: 100%;
  padding: 0 15px;
  flex: 1 0 0;

  @media ${releaseInfoTabletDownQuery} {
    padding: 0 16px;
    flex-basis: 100% !important;
    max-width: 100% !important;
  }
`

export const ActionsSectionInline = styled.div`
  width: 100%;
  box-sizing: border-box;

  @media ${releaseInfoTabletDownQuery} {
    padding: 0 16px;
  }

  @media ${releaseInfoLargeDesktopUpQuery} {
    width: auto;
    margin-left: auto;
    flex: 0 0 auto;
  }
`

export const ActionsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  padding: 8px 0;

  @media ${releaseInfoTabletUpQuery} {
    justify-content: flex-end;
  }

  @media ${releaseInfoTabletDownQuery} {
    justify-content: flex-start;
  }

  @media ${releaseInfoSmallDesktopUpQuery} {
    justify-content: flex-end;
  }

  @media ${releaseInfoLargeDesktopUpQuery} {
    padding: 0;
  }
`

export const ActionButton = styled.div`
  display: flex;
  flex-direction: row;
  column-gap: 16px;

  @media ${releaseInfoMobileDownQuery} {
    width: 100%;
    justify-content: space-between;
  }

  @media ${releaseInfoTabletDownQuery} {
    width: 100%;
    column-gap: 8px;
    margin-left: -14px !important;
  }
`

export const ActionTileButton = styled.button`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  width: 66px;
  min-height: 68px;
  padding: 8px 4px;
  border: 0;
  border-radius: 5px;
  background-color: ${({ theme, $isActive }) =>
    $isActive ? theme.colors.neutralW30 : 'transparent'};
  cursor: pointer;
  font-size: 12px;
  font-weight: 400;
  color: ${({ theme }) => theme.colors.neutralW70};

  @media ${releaseInfoMobileDownQuery} {
    flex: 1 1 0;
    width: auto;
    min-width: 0;
    min-height: 56px;
    padding: 8px 2px;
  }

  &:hover {
    background-color: ${({ theme }) => theme.colors.neutralW30};
  }

  &:focus-visible {
    color: ${({ theme }) => theme.colors.neutralW70};
    background-color: ${({ theme }) => theme.colors.neutralW30};
    outline: ${({ theme }) => `2px solid ${theme.colors.interact70}`};
    outline-offset: 2px;
  }
`

export const ActionTileIconWrapper = styled.span`
  display: inline-block;
  width: 24px;
  height: 24px;
  flex-shrink: 0;
  z-index: 1;
  color: ${({ theme }) => theme.colors.neutralW70};
  transform: translateX(${({ $offsetX = 0 }) => `${$offsetX}px`});

  svg {
    width: 24px;
    height: 24px;
  }
`

export const ActionTileLabel = styled.span`
  width: 100%;
  text-align: center;
  z-index: 0;
  white-space: normal;
  overflow: visible;
  text-overflow: clip;
  line-height: 12px;
  color: inherit;

  @media ${releaseInfoMobileDownQuery} {
    word-break: break-word;
  }
`
